import { AfterViewInit, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material';
import { UserService } from './services/user.service';
import { GLOBAL } from 'src/app/services/global';
import { Title } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeCL from '@angular/common/locales/es-CL';
registerLocaleData(localeCL, 'cl');
var AppComponent = /** @class */ (function () {
    function AppComponent(dialog, _userService, elementRef, titleService) {
        this.dialog = dialog;
        this._userService = _userService;
        this.elementRef = elementRef;
        this.titleService = titleService;
        this.title = GLOBAL.nombreMuni.toUpperCase();
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
        titleService.setTitle("Smart DOM - MUNICIPALIDAD DE " + GLOBAL.nombreMuni.toUpperCase());
    }
    AppComponent.prototype.ngDoCheck = function () {
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
    };
    AppComponent.prototype.ngAfterViewInit = function () {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F5F0';
    };
    return AppComponent;
}());
export { AppComponent };
